module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称:"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.company),
      callback: function($$v) {
        _vm.$set(_vm.filters, "company", $$v)
      },
      expression: "filters.company"
    }
  }, _vm._l((_vm.companies), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "设备状态:"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.filters.state),
      callback: function($$v) {
        _vm.$set(_vm.filters, "state", $$v)
      },
      expression: "filters.state"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": null
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("正常")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("预警")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("告警")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("故障")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getDevices
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    ref: "deviceTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.devices,
      "highlight-current-row": "",
      "border": "",
      "row-class-name": _vm.tableRowClassName
    },
    on: {
      "row-click": _vm.rowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "label": "设备ID",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.deviceId) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "label": "设备类型",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(!scope.row.deviceId.startsWith('9') ? '终端' : scope.row.deviceId.startsWith('91') ? '骐骏独立式探测器' : '威胜独立式探测器') + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "port",
      "label": "端口",
      "width": "80",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "name",
      "label": "设备名称",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "company",
      "label": "所属客户",
      "min-width": "170",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "group",
      "label": "所属区域",
      "min-width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "location",
      "label": "设备位置",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "createdAt",
      "formatter": _vm.formatTime,
      "label": "创建时间",
      "min-width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "prop": "online",
      "label": "是否在线",
      "min-width": "100",
      "align": "center",
      "fixed": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.online == null || !scope.row.online) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(_vm._f("filterOnline")(scope.row.online)) + "\n        ")]) : _vm._e(), _vm._v(" "), (scope.row.online) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(_vm._f("filterOnline")(scope.row.online)) + "\n        ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "label": "当前状态",
      "width": "100",
      "align": "center",
      "fixed": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.disconState) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "close-transition": ""
          }
        }, [_vm._v("断闸\n        ")]) : _vm._e(), _vm._v(" "), (!scope.row.disconState && scope.row.state === 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(_vm._f("filterState")(scope.row.state)) + "\n        ")]) : _vm._e(), _vm._v(" "), (!scope.row.disconState && scope.row.state === 2) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(_vm._f("filterState")(scope.row.state)) + "\n        ")]) : _vm._e(), _vm._v(" "), (!scope.row.disconState && scope.row.state === 3) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(_vm._f("filterState")(scope.row.state)) + "\n        ")]) : _vm._e(), _vm._v(" "), (!scope.row.disconState && scope.row.state === 4) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(_vm._f("filterState")(scope.row.state)) + "\n        ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "启动/停止",
      "width": "100",
      "align": "center",
      "fixed": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.start) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary",
            "disabled": !scope.row.online
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.handleStart(scope.$index, scope.row)
            }
          }
        }, [_vm._v("启动")]) : _vm._e(), _vm._v(" "), (scope.row.start) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger",
            "disabled": !scope.row.online
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.handleStop(scope.$index, scope.row)
            }
          }
        }, [_vm._v("停止")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增设备",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-steps', {
    attrs: {
      "active": _vm.active,
      "finish-status": "success",
      "space": 200,
      "align-center": "",
      "center": ""
    }
  }, [_c('el-step', {
    attrs: {
      "title": "基本信息"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "采集参数"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "其他配置"
    }
  })], 1), _vm._v(" "), _c('el-form', {
    ref: "addForm",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "model": _vm.addForm,
      "label-width": "120px",
      "rules": _vm.addFormRules
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 1),
      expression: "active == 1"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属客户",
      "prop": "companyId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.companyChange
    },
    model: {
      value: (_vm.addForm.companyId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "companyId", $$v)
      },
      expression: "addForm.companyId"
    }
  }, _vm._l((_vm.companies), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属区域",
      "prop": "groupId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.groupId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "groupId", $$v)
      },
      expression: "addForm.groupId"
    }
  }, _vm._l((_vm.groups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备ID",
      "prop": "deviceId"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 12
    },
    model: {
      value: (_vm.addForm.deviceId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "deviceId", $$v)
      },
      expression: "addForm.deviceId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.addForm.deviceId && (!_vm.addForm.deviceId.startsWith('9') ? '终端' : _vm.addForm.deviceId.startsWith('91') ? '骐骏独立式探测器' : '威胜独立式探测器')) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备别名",
      "prop": "alias"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.alias),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "alias", $$v)
      },
      expression: "addForm.alias"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备位置",
      "prop": "location"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.location),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "location", $$v)
      },
      expression: "addForm.location"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 2),
      expression: "active == 2"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "采集频率(分钟):"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "controls": false,
      "min": 5,
      "step": 1,
      "max": 45
    },
    model: {
      value: (_vm.addForm.rate),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "rate", $$v)
      },
      expression: "addForm.rate"
    }
  })], 1), _vm._v(" "), (!_vm.addForm.deviceId.startsWith('9')) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "相线CT:"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "controls": false,
      "min": 1,
      "max": 600,
      "step": 1
    },
    model: {
      value: (_vm.addForm.ct),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "ct", $$v)
      },
      expression: "addForm.ct"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "零线CT:"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "controls": false,
      "min": 1,
      "max": 600,
      "step": 1
    },
    model: {
      value: (_vm.addForm.lct),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "lct", $$v)
      },
      expression: "addForm.lct"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "PT:"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "controls": false,
      "min": 1,
      "max": 600,
      "step": 1
    },
    model: {
      value: (_vm.addForm.pt),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "pt", $$v)
      },
      expression: "addForm.pt"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "断路功能",
      "prop": "canBreak"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "是",
      "off-text": "否"
    },
    model: {
      value: (_vm.addForm.canBreak),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "canBreak", $$v)
      },
      expression: "addForm.canBreak"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否启用"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "是",
      "off-text": "否"
    },
    model: {
      value: (_vm.addForm.enable),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "enable", $$v)
      },
      expression: "addForm.enable"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 3),
      expression: "active == 3"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(!_vm.addForm.deviceId.startsWith('9')) ? [_c('el-form', {
    ref: "paramsAddForm",
    attrs: {
      "inline": true,
      "model": _vm.paramsAddForm,
      "rules": _vm.paramsAddFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "变量名称:",
      "prop": "paramsType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.paramsAddForm.paramsType),
      callback: function($$v) {
        _vm.$set(_vm.paramsAddForm, "paramsType", $$v)
      },
      expression: "paramsAddForm.paramsType"
    }
  }, _vm._l((_vm.names), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.name,
        "value": item.type
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "预警值:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 999
    },
    model: {
      value: (_vm.paramsAddForm.warnUp),
      callback: function($$v) {
        _vm.$set(_vm.paramsAddForm, "warnUp", $$v)
      },
      expression: "paramsAddForm.warnUp"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addFromParamsSubmit
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.addForm.deviceId.startsWith('9')) ? [_c('el-form', {
    ref: "paramsAddForm",
    attrs: {
      "inline": true,
      "model": _vm.paramsAddForm,
      "rules": _vm.paramsAddFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "通道名称:",
      "prop": "channel"
    }
  }, [(_vm.addForm.deviceId.startsWith('91')) ? _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.paramsAddForm.channel),
      callback: function($$v) {
        _vm.$set(_vm.paramsAddForm, "channel", $$v)
      },
      expression: "paramsAddForm.channel"
    }
  }, _vm._l((_vm.names3), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.name,
        "value": item.type
      }
    })
  })) : _vm._e(), _vm._v(" "), (!_vm.addForm.deviceId.startsWith('91')) ? _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.paramsAddForm.channel),
      callback: function($$v) {
        _vm.$set(_vm.paramsAddForm, "channel", $$v)
      },
      expression: "paramsAddForm.channel"
    }
  }, _vm._l((_vm.names2), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.name,
        "value": item.type
      }
    })
  })) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "通道类型:",
      "prop": "channelType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.paramsAddForm.channelType),
      callback: function($$v) {
        _vm.$set(_vm.paramsAddForm, "channelType", $$v)
      },
      expression: "paramsAddForm.channelType"
    }
  }, _vm._l((_vm.channelTypes), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.name,
        "value": item.type
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "通道别名:",
      "prop": "channelAlias"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.paramsAddForm.channelAlias),
      callback: function($$v) {
        _vm.$set(_vm.paramsAddForm, "channelAlias", $$v)
      },
      expression: "paramsAddForm.channelAlias"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "预警值:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 999
    },
    model: {
      value: (_vm.paramsAddForm.warnUp),
      callback: function($$v) {
        _vm.$set(_vm.paramsAddForm, "warnUp", $$v)
      },
      expression: "paramsAddForm.warnUp"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addFromParamsSubmit
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)] : _vm._e()], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "paramsTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.deviceAddParams,
      "highlight-current-row": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "deviceId",
      "header-align": "center",
      "label": "设备ID",
      "align": "center",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "device",
      "header-align": "center",
      "align": "center",
      "label": "设备名称",
      "min-width": "140"
    }
  }), _vm._v(" "), (_vm.addForm.deviceId.startsWith('9')) ? _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": "通道名称",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                通道" + _vm._s(scope.row.channel) + "\n              ")]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.addForm.deviceId.startsWith('9')) ? _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": "通道类型",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.channelType == 1 ? '电流' : '温度') + "\n              ")]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.addForm.deviceId.startsWith('9')) ? _c('el-table-column', {
    attrs: {
      "prop": "channelAlias",
      "header-align": "center",
      "align": "center",
      "label": "通道别名",
      "min-width": "120"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.addForm.deviceId.startsWith('9')) ? _c('div', [_c('el-table-column', {
    attrs: {
      "prop": "paramsType",
      "formatter": _vm.formatParamType,
      "header-align": "center",
      "align": "center",
      "label": "变量名称",
      "min-width": "120"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": "预警值",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.warnUp) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createdAt",
      "header-align": "center",
      "align": "center",
      "label": "创建时间",
      "formatter": _vm.formatTime,
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleDelParamsAddForm(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.active == 2 || _vm.active == 3) ? _c('el-button', {
    staticStyle: {
      "margin-top": "12px"
    },
    on: {
      "click": _vm.prev
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (_vm.active < 3) ? _c('el-button', {
    staticStyle: {
      "margin-top": "12px"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("下一步")]) : _vm._e(), _vm._v(" "), (_vm.active == 3) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑设备",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属客户",
      "prop": "companyId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": true
    },
    on: {
      "change": _vm.companyChange
    },
    model: {
      value: (_vm.editForm.companyId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "companyId", $$v)
      },
      expression: "editForm.companyId"
    }
  }, _vm._l((_vm.companies), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属区域",
      "prop": "groupId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": true
    },
    model: {
      value: (_vm.editForm.groupId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "groupId", $$v)
      },
      expression: "editForm.groupId"
    }
  }, _vm._l((_vm.groups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备ID",
      "prop": "deviceId"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.editForm.deviceId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "deviceId", $$v)
      },
      expression: "editForm.deviceId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备别名",
      "prop": "alias"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editForm.alias),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "alias", $$v)
      },
      expression: "editForm.alias"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备位置",
      "prop": "location"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editForm.location),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "location", $$v)
      },
      expression: "editForm.location"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "断路功能",
      "prop": "canBreak"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "是",
      "off-text": "否"
    },
    model: {
      value: (_vm.editForm.canBreak),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "canBreak", $$v)
      },
      expression: "editForm.canBreak"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否启用"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "是",
      "off-text": "否"
    },
    model: {
      value: (_vm.editForm.enable),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "enable", $$v)
      },
      expression: "editForm.enable"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paramSettingVisible),
      expression: "paramSettingVisible"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-tabs', {
    staticClass: "panel",
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "通道别名与预警设置"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.selectedRow && !_vm.selectedRow.deviceId.startsWith('9')) ? [_c('el-form', {
    ref: "paramsForm",
    attrs: {
      "inline": true,
      "model": _vm.paramsForm,
      "rules": _vm.paramsFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "变量名称:",
      "prop": "paramsType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.paramsForm.paramsType),
      callback: function($$v) {
        _vm.$set(_vm.paramsForm, "paramsType", $$v)
      },
      expression: "paramsForm.paramsType"
    }
  }, _vm._l((_vm.names), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.name,
        "value": item.type
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "预警值:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 999
    },
    model: {
      value: (_vm.paramsForm.warnUp),
      callback: function($$v) {
        _vm.$set(_vm.paramsForm, "warnUp", $$v)
      },
      expression: "paramsForm.warnUp"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addParamsSubmit
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.selectedRow && _vm.selectedRow.deviceId.startsWith('9')) ? [_c('el-form', {
    ref: "paramsForm",
    attrs: {
      "inline": true,
      "model": _vm.paramsForm,
      "rules": _vm.paramsFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "通道名称:",
      "prop": "channel"
    }
  }, [(_vm.selectedRow.deviceId.startsWith('91')) ? _c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.paramsForm.channel),
      callback: function($$v) {
        _vm.$set(_vm.paramsForm, "channel", $$v)
      },
      expression: "paramsForm.channel"
    }
  }, _vm._l((_vm.names3), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.name,
        "value": item.type
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.selectedRow && !_vm.selectedRow.deviceId.startsWith('91')) ? _c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.paramsForm.channel),
      callback: function($$v) {
        _vm.$set(_vm.paramsForm, "channel", $$v)
      },
      expression: "paramsForm.channel"
    }
  }, _vm._l((_vm.names2), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.name,
        "value": item.type
      }
    })
  })) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "通道类型:",
      "prop": "channelType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.paramsForm.channelType),
      callback: function($$v) {
        _vm.$set(_vm.paramsForm, "channelType", $$v)
      },
      expression: "paramsForm.channelType"
    }
  }, _vm._l((_vm.channelTypes), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.name,
        "value": item.type
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "通道别名:",
      "prop": "channelAlias"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.paramsForm.channelAlias),
      callback: function($$v) {
        _vm.$set(_vm.paramsForm, "channelAlias", $$v)
      },
      expression: "paramsForm.channelAlias"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "预警值:"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "controls": false,
      "min": 1,
      "max": 999
    },
    model: {
      value: (_vm.paramsForm.warnUp),
      callback: function($$v) {
        _vm.$set(_vm.paramsForm, "warnUp", $$v)
      },
      expression: "paramsForm.warnUp"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addParamsSubmit
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)] : _vm._e()], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.paramsListLoading),
      expression: "paramsListLoading"
    }],
    ref: "paramsTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.deviceParams,
      "highlight-current-row": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "label": "设备ID",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.selectedRow.deviceId) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "device",
      "header-align": "center",
      "align": "center",
      "label": "设备名称",
      "min-width": "140"
    }
  }), _vm._v(" "), (_vm.selectedRow && _vm.selectedRow.deviceId.startsWith('9')) ? _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": "通道名称",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                通道" + _vm._s(scope.row.channel) + "\n              ")]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.selectedRow && _vm.selectedRow.deviceId.startsWith('9')) ? _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": "通道类型",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.channelType == 1 ? '电流' : '温度') + "\n              ")]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.selectedRow && _vm.selectedRow.deviceId.startsWith('9')) ? _c('el-table-column', {
    attrs: {
      "prop": "channelAlias",
      "header-align": "center",
      "align": "center",
      "label": "通道别名",
      "min-width": "120"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedRow && !_vm.selectedRow.deviceId.startsWith('9')) ? _c('div', [_c('el-table-column', {
    attrs: {
      "prop": "paramsType",
      "formatter": _vm.formatParamType,
      "header-align": "center",
      "align": "center",
      "label": "变量名称",
      "min-width": "120"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": "预警值",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.warnUp) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createdAt",
      "header-align": "center",
      "align": "center",
      "label": "创建时间",
      "formatter": _vm.formatTime,
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleDelParams(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "参数设置"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.collectorLoading),
      expression: "collectorLoading"
    }],
    ref: "collectorForm",
    attrs: {
      "inline": true,
      "model": _vm.collectorForm
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "采集频率(分钟):"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "controls": false,
      "min": 5,
      "max": 45,
      "step": 1
    },
    model: {
      value: (_vm.collectorForm.rate),
      callback: function($$v) {
        _vm.$set(_vm.collectorForm, "rate", $$v)
      },
      expression: "collectorForm.rate"
    }
  })], 1), _vm._v(" "), (_vm.selectedRow && !_vm.selectedRow.deviceId.startsWith('9')) ? [_c('el-form-item', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "相线CT:"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "controls": false,
      "min": 1,
      "max": 600,
      "step": 1
    },
    model: {
      value: (_vm.collectorForm.ct),
      callback: function($$v) {
        _vm.$set(_vm.collectorForm, "ct", $$v)
      },
      expression: "collectorForm.ct"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "零线CT:"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "controls": false,
      "min": 1,
      "max": 600,
      "step": 1
    },
    model: {
      value: (_vm.collectorForm.lct),
      callback: function($$v) {
        _vm.$set(_vm.collectorForm, "lct", $$v)
      },
      expression: "collectorForm.lct"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "PT:"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "controls": false,
      "min": 1,
      "max": 600,
      "step": 1
    },
    model: {
      value: (_vm.collectorForm.pt),
      callback: function($$v) {
        _vm.$set(_vm.collectorForm, "pt", $$v)
      },
      expression: "collectorForm.pt"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveCollectorParams
    }
  }, [_vm._v("保存")])], 1)], 2)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-423c211a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/Device.vue
// module id = 1303
// module chunks = 1